import moment from 'moment';
import VueClipboards from 'vue-clipboards';

import { datadogRum } from '@datadog/browser-rum';

import Vue from 'vue';
import smoothscroll from 'smoothscroll-polyfill';

import PrismicVue from '@prismicio/vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import './plugins/element';
import { httpAuth, httpNoAuth, httpPin } from './utils/axios-utils';
import './plugins/add-to-calendar';
import FontAwesomeIcon from './components/common/FontAwesome.vue';
import './plugins/fas-lib';

const endpoint = 'https://assemble-documentations.prismic.io/api/v2';

Vue.use(PrismicVue, {
  endpoint,
  apiOptions: {},
});

if (process.env.VUE_APP_DD_APP_ID) {
  datadogRum.init({
    applicationId: process.env.VUE_APP_DD_APP_ID,
    clientToken: process.env.VUE_APP_DD_APP_KEY,
    site: 'datadoghq.com',
    service: 'assemble-portal',
    env: process.env.VUE_APP_DD_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    version: process.env.DATADOG_VERSION,
    sampleRate: 100,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'allow'
  });

  datadogRum.startSessionReplayRecording();
}
Vue.use(VueClipboards);
Vue.component('fa-icon', FontAwesomeIcon);

// Apply the polyfill
smoothscroll.polyfill();

/* ---- Vue Compoments ---- */
// Global Layouts
Vue.component('app-layout', () => import('./layouts/AppLayout.vue'));

// Page Layouts
Vue.component('content-header', () => import('./components/layouts/ContentHeader.vue'));
Vue.component('content-header-custom', () => import('./components/layouts/ContentHeaderCustom.vue'));
Vue.component('content-body-card', () => import('./components/layouts/ContentBodyCard.vue'));

// Custom Elements
Vue.component('el-input-title', () => import('./components/elements/ElInputTitle.vue'));
Vue.component('el-date-input', () => import('./components/elements/ElDateInput.vue'));
Vue.component('el-qty-input', () => import('./components/elements/ElQtyInput.vue'));
Vue.component('el-price-input', () => import('./components/elements/ElPriceInput.vue'));

// Others
Vue.component('google-auto-complete', () => import('./components/others/VueGoogleAutocomplete.vue'));
Vue.component('credit-card', () => import('./components/others/CreditCard.vue'));
Vue.component('vue-upload-component', () => import('vue-upload-component'));

Vue.config.productionTip = false;

// Vue Prototypes
Vue.prototype.$httpNoAuth = httpNoAuth;
Vue.prototype.$http = httpAuth;
Vue.prototype.$httpPin = httpPin;
Vue.prototype.moment = moment;

Vue.prototype.pin = new Pin.Api(process.env.VUE_APP_PIN_PK, process.env.VUE_APP_PIN_ENV);

// Vue google map custom
Vue.prototype.$gmapApiPromiseLazy = () => new Promise((resolve) => resolve());
Vue.prototype.$gmapOptions = { autobindAllEvents: false };

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
